import ReceiveItem from './ReceiveItem';
export default ReceiveItem;
